'use strict';

var React = require('react'),
    Analytics = require('../utils/Analytics'),
    AnalyticsEvents = require('../constants/AnalyticsEvents'),
    StampActionCreators = require('../actions/StampActionCreators'),
    FeedWithTrendingStore = require('../stores/FeedWithTrendingStore'),
    StampStore = require('../stores/StampStore'),
    ZineStore = require('../stores/ZineStore'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    Group = require('../organisms/Group'),
    EmptyState = require('../molecules/EmptyState'),
    DocumentTitle = require('../atoms/DocumentTitle'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    PageQueryMixin = require('../mixins/PageQueryMixin'),
    { isInitialPath } = require('../router'),
    { pluck } = require('underscore'),
    { PropTypes } = React;

var FeedPage = React.createClass({
  mixins: [
    createStoreMixin(FeedWithTrendingStore, StampStore, ZineStore),
    PageQueryMixin,
    PureRenderMixin
  ],

  propTypes: {
    isScrolled: PropTypes.bool.isRequired
  },

  getStateFromStores() {
    return {
      keyedStamps: FeedWithTrendingStore.getKeyedStamps(),
      isInvalidated: FeedWithTrendingStore.isInvalidated(),
      isLastPage: FeedWithTrendingStore.isLastPage(),
      isExpectingPage: FeedWithTrendingStore.isExpectingPage()
    };
  },

  getStampItemProps(stamp, index) {
    var { keyedStamps } = this.state,
        { isTrending } = keyedStamps[index],
        primaryZine = StampStore.getPrimaryZine(stamp.id);

    return {
      isTrending: isTrending,
      primaryZine: primaryZine
    };
  },

  componentDidMount() {
    StampActionCreators.requestFeedWithTrendingPage(true, !isInitialPath());
    Analytics.trackEvent(AnalyticsEvents.FEED_VIEW);
  },

  componentDidUpdate(prevProps, prevState) {
    var didInvalidate = this.state.isInvalidated && !prevState.isInvalidated;
    if (didInvalidate && !this.state.isExpectingPage) {
      StampActionCreators.requestFeedWithTrendingPage(true, true);
    }
  },

  render() {
    var { isScrolled } = this.props,
        { keyedStamps, isInvalidated, isExpectingPage, isLastPage } = this.state;

    return (
      <DocumentTitle title='My Feed'>
        <Group type='stamps'
               mode='grid'
               columns={3}
               context='page'
               keys={pluck(keyedStamps, 'key')}
               items={pluck(keyedStamps, 'item')}
               getItemProps={this.getStampItemProps}
               isExpectingPage={isExpectingPage}
               isLastPage={isLastPage}
               isInvalidated={isInvalidated}
               showInvalidationFeedback={!isScrolled}
               defaultPage={this.parsePage()}
               onPageChange={this.replacePage}
               loadNextPage={this.requestNextPage}>
          <EmptyState label='Something went wrong. Please refresh the page or try again later.'
                      absoluteCenter />
        </Group>
      </DocumentTitle>
    );
  },

  requestNextPage() {
    StampActionCreators.requestFeedWithTrendingPage();
  }
});

module.exports = FeedPage;



/** WEBPACK FOOTER **
 ** ./pages/FeedPage.jsx
 **/